import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import mea from '../../../services/mea';
import { PATH } from '../../../constants/path';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './TermsPage.scss';

class TermsPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgu">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{i18n.TEXT1_1}</p>
                <p>{i18n.TEXT1_4}</p>
                <p>{i18n.TEXT1_5}</p>
                <p>{i18n.TEXT1_6}</p>
                <p>{i18n.TEXT1_7}</p>
                <p>{i18n.TEXT1_8}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_1)}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>{i18n.TEXT5_3}</p>
                <p>{i18n.TEXT5_4}</p>
                <ul>
                    <li>{i18n.TEXT5_5}</li>
                    <li>{i18n.TEXT5_6}</li>
                    <li>{i18n.TEXT5_7}</li>
                </ul>
                <p>{i18n.TEXT5_8}</p>
                <ul>
                    <li>{i18n.TEXT5_9}</li>
                    <li>{i18n.TEXT5_10}</li>
                    <li>{i18n.TEXT5_11}</li>
                </ul>
                <p>{i18n.TEXT5_12}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>
                <p>{i18n.TEXT6_3}</p>
                <p>{i18n.TEXT6_4}</p>
                <ul>
                    <li>{i18n.TEXT6_5}</li>
                    <li>{i18n.TEXT6_6}</li>
                </ul>
                <p>{i18n.TEXT6_7}</p>
                <p>{i18n.TEXT6_8}</p>
                <p>{i18n.TEXT6_9}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
                <p>{i18n.TEXT8_2}</p>
                <p>{i18n.TEXT8_3}</p>
                <p>{i18n.TEXT8_4}</p>
                <p>{i18n.TEXT8_5}</p>
                <p>{i18n.TEXT8_6}</p>
                <p>{i18n.TEXT8_7}</p>
                <p>{i18n.TEXT8_8}</p>

                <div id="personal-data" />
                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>
                <p>{i18n.TEXT9_3}</p>
                <p>{i18n.TEXT9_5}</p>
                <p>{i18n.TEXT9_5_2}</p>
                <p>{i18n.TEXT9_5_3}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT9_6)}</p>
                <p>{i18n.TEXT9_7}</p>
                <p>{i18n.TEXT9_8}</p>
                <p>{i18n.TEXT9_9}</p>

                <div id="cookie-policy" />
                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
                <p>{i18n.TEXT10_2}</p>
                <p>{i18n.TEXT10_3}</p>

                <h3>{i18n.TITLE11}</h3>
                <p>{i18n.TEXT11_1}</p>
                <p>{i18n.TEXT11_2}</p>
                <p>{i18n.TEXT11_3}</p>
                <p>{i18n.TEXT11_4}</p>

                <h3>{i18n.TITLE12}</h3>
                <p>{i18n.TEXT12_1}</p>
                <p>{i18n.TEXT12_2}</p>
                <p>{i18n.TEXT12_3}</p>

                <h3>{i18n.TITLE13}</h3>
                <p>{i18n.TEXT13_1}</p>
                <p>{i18n.TEXT13_2}</p>
                <ul>
                    <li>{i18n.TEXT13_3}</li>
                    <li>{i18n.TEXT13_4}</li>
                </ul>

                <h3>{i18n.TITLE14}</h3>
                <p>{i18n.TEXT14_1}</p>
                <p>{i18n.TEXT14_2}</p>

                <h3>{i18n.TITLE15}</h3>
                <p>{i18n.TEXT15_1}</p>

                <h3>{i18n.TITLE16}</h3>
                <p>{i18n.TEXT16_1}</p>
                <p>{i18n.TEXT16_2}</p>
                <p>{i18n.TEXT16_3}</p>

                <h3>{i18n.TITLE17}</h3>
                <p>{i18n.TEXT17_1}</p>

                <h3>{i18n.TITLE18}</h3>
                <p>{i18n.TEXT18_1}</p>

                <h3>{i18n.TITLE19}</h3>
                <p>{i18n.TEXT19_1}</p>
                <p>{i18n.TEXT19_2}</p>
                <p>{i18n.TEXT19_3}</p>

                <h3>{i18n.TITLE20}</h3>
                <p>{i18n.TEXT20_1}</p>
                <p>{i18n.TEXT20_2}</p>
                <p>{i18n.TEXT20_3}</p>
            </main>
        );
    }
}

TermsPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.TERMS,
        mea: mea.selectors.getMeasListByTypeId(state, mea.constants.BOOSTED_OFFER_MEA_TYPE)[0]
    };
}

export default withTemplate(connect(mapStateToProps)(TermsPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPage.js